(function () {
  var root = document.querySelector('[data-np]');
  if (!root) return;
  var cfg = JSON.parse(root.getAttribute('data-cfg'));
  var exEl = root.querySelector('[data-np-extras]');
  var extras = exEl ? JSON.parse(exEl.textContent || '[]') : [];
  var S = { mode: cfg.defaultMode, dur: 36, care: false, cf: 'none', inst: false, q: {}, qty: 1, cat: 'Tous', glReady: false };
  var QMAX = 10;
  var $ = function (r) { return root.querySelector('[data-role="' + r + '"]'); };
  var DURS = [12, 24, 36];
  var TOP_N = 2;

  // Nector Care v3 : 3 équipements inclus, +4,90 €/mois par équipement en plus.
  // Achat : produits Shopify Subscriptions (sans engagement 19,90 / 12 mois 16,90 / supplémentaire 4,90). Location : 14,90, confirmé chez GreenLeaze (pas de ligne panier).
  var CARE = { rent: 1490, incl: 3, url: '/pages/nector-care', handles: { none: 'nector-care-plus', m12: 'nector-care-start-1', extra: 'nector-care-ultim-1' }, data: null, glNote: null };

  function f(n) { n = Math.round(n * 100) / 100; return Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ','); }
  function eur(c) { return c / 100; }

  // Règles GreenLeaze : prix HT = TTC / 1,2 ; m = mensualité, i = apport initial (1er versement = m + i)
  function gl(cents, d) {
    if (!S.glReady || typeof getRuleByProductPriceAndDuration !== 'function') return null;
    try {
      var r = getRuleByProductPriceAndDuration((cents / 100) / 1.2, d);
      if (!r) return null;
      return { m: Number(r.monthly), i: Number(r.initial) };
    } catch (e) { return null; }
  }
  function ready(cb) {
    if (!cfg.rentOk && !extras.some(function (e) { return e.rent; })) { cb(); return; }
    var done = false;
    var go = function () { if (done) return; done = true; S.glReady = !!window.initPriceGreenleaze; cb(); };
    if (window.initPriceGreenleaze) { go(); return; }
    window.addEventListener('greenleazePriceActualize', go, { once: true });
    setTimeout(go, 6000);
  }

  // Chargement des 3 produits Care (ids de variantes + plans d'abonnement)
  function loadCare() {
    var hs = [CARE.handles.none, CARE.handles.m12, CARE.handles.extra];
    var root0 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    Promise.all(hs.map(function (h) {
      return fetch(root0 + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (r) {
      var pick = function (p) {
        if (!p || !p.variants || !p.variants[0] || !p.selling_plan_groups || !p.selling_plan_groups[0] || !p.selling_plan_groups[0].selling_plans || !p.selling_plan_groups[0].selling_plans[0]) return null;
        return { id: p.variants[0].id, plan: p.selling_plan_groups[0].selling_plans[0].id, price: p.variants[0].price };
      };
      var a = pick(r[0]), b = pick(r[1]), c = pick(r[2]);
      if (a && b && c) { CARE.data = { none: a, m12: b, extra: c }; render(); }
    });
  }

  function visibleExtras() {
    return extras.filter(function (e) { return S.mode === 'louer' ? e.rent : e.avail; });
  }
  function accCount() {
    var n = 0; visibleExtras().forEach(function (e) { n += (S.q[e.id] || 0); }); return n;
  }
  function careExtraN() { return Math.max(0, S.qty + accCount() - CARE.incl); }
  function careBase(rent) { return rent ? eur(CARE.rent) : (CARE.data ? eur(CARE.data[S.cf].price) : 0); }
  function careExtraUnit(rent) { return CARE.data ? eur(CARE.data.extra.price) : 4.9; }
  function careAmt(rent) { return careBase(rent) + careExtraN() * careExtraUnit(rent); }

  function extraPrice(e) {
    if (S.mode === 'louer') { var g = gl(e.price, S.dur); return g ? g.m : 0; }
    return eur(e.price);
  }
  function qtyBox(e) {
    var n = S.q[e.id] || 0;
    return '<div class="np-qty"><button type="button" data-x="' + e.id + '" data-d="-1">−</button><span>' + n + '</span><button type="button" data-x="' + e.id + '" data-d="1">+</button></div>';
  }
  // Carte accessoire (même présentation dans la fiche et dans le volet) : image et titre cliquables vers la fiche
  function itemHtml(e, rent) {
    var link = e.url ? ' href="' + e.url + '" target="_blank" rel="noopener"' : '';
    var img = e.img ? '<a class="np-it-img"' + link + '><img src="' + e.img + '" alt="" loading="lazy"></a>' : '';
    return '<div class="np-it">' + img + '<b><a' + link + '>' + e.title + '</a></b><div class="np-it-row"><span>+' + f(extraPrice(e)) + (rent ? ' €/mois' : ' €') + '</span>' + qtyBox(e) + '</div></div>';
  }

  // Sélecteur de quantité du produit principal (− / +), juste sous le tarif : les prix affichés suivent la quantité
  function mountQty() {
    if (root.querySelector('[data-role="qtyp"]')) return;
    var anchor = root.querySelector('.np-accd') || $('cta'); if (!anchor) return;
    var st = document.createElement('style');
    st.textContent = '.np-qp{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:14px 0;padding:10px 14px;border:1.5px solid #e3e5ec;border-radius:14px;background:#fff;width:100%;box-sizing:border-box;flex:0 0 100%}.np-qp>span{font-weight:600;font-size:14.5px;color:var(--np-navy,#00033e)}.np-qp>span small{display:block;font-weight:500;font-size:12px;color:#5b5f7a}.np-qp .ctl{display:inline-flex;align-items:center;gap:6px}.np-qp .ctl button{width:36px;height:36px;border-radius:50%;border:1.5px solid var(--np-navy,#00033e);background:#fff;color:var(--np-navy,#00033e);font-size:20px;line-height:1;cursor:pointer;font-family:inherit;padding:0}.np-qp .ctl button:disabled{opacity:.35;cursor:default}.np-qp .ctl b{min-width:34px;text-align:center;font-size:17px}';
    document.head.appendChild(st);
    var d = document.createElement('div');
    d.className = 'np-qp'; d.setAttribute('data-role', 'qtyp');
    d.innerHTML = '<span>Quantité<small data-role="qh"></small></span><div class="ctl"><button type="button" data-q data-qd="-1" aria-label="Diminuer la quantité">−</button><b data-role="qv">1</b><button type="button" data-q data-qd="1" aria-label="Augmenter la quantité">+</button></div>';
    anchor.parentNode.insertBefore(d, anchor);
  }

  var styled = false;
  function careStyle() {
    if (styled) return; styled = true;
    var st = document.createElement('style');
    st.textContent = '.np-fms{display:flex;flex-wrap:wrap;gap:6px;margin:6px 0 8px}.np-fm{border:1.5px solid var(--np-navy,#00033e);background:#fff;color:var(--np-navy,#00033e);border-radius:999px;padding:5px 12px;font-size:12.5px;font-weight:600;cursor:pointer;font-family:inherit}.np-fm.on{background:var(--np-navy,#00033e);color:#fff}';
    document.head.appendChild(st);
  }
  function renderCare(rent, tot) {
    var row = $('care-row'); if (!row) return;
    row.hidden = !rent && !CARE.data;
    var xn = careExtraN();
    var b = row.querySelector('div > b'); if (b) b.textContent = '+' + f(careBase(rent)) + ' €/mois';
    var list = row.querySelector('.np-care-list');
    if (list && !row.hidden) {
      careStyle();
      var h = '';
      if (!rent) {
        h += '<div class="np-fms"><button type="button" class="np-fm' + (S.cf === 'none' ? ' on' : '') + '" data-care-f="none">Sans engagement · ' + f(eur(CARE.data.none.price)) + ' €</button><button type="button" class="np-fm' + (S.cf === 'm12' ? ' on' : '') + '" data-care-f="m12">12 mois · ' + f(eur(CARE.data.m12.price)) + ' €</button></div>';
      }
      h += '<p class="np-tk">Experts 5j/7 + assistant IA 24h/24</p>';
      h += '<p class="np-tk">Diagnostic à distance et petite assistance inclus</p>';
      h += '<p class="np-tk">' + (rent ? 'Casse et vol couverts par GreenLeaze, franchise remboursée jusqu\'à 75 €/an' : 'Casse et vol couverts : franchise 10 % (min. 10 €), 2 casses et 1 vol par an') + '</p>';
      h += '<p class="np-tk">Remplacement express sous 48 à 72 h après diagnostic</p>';
      h += '<p class="np-tk">3 équipements inclus, +' + f(careExtraUnit(rent)) + ' €/mois par équipement en plus' + (xn ? ' (' + xn + ' en plus dans votre sélection : +' + f(xn * careExtraUnit(rent)) + ' €/mois)' : '') + '</p>';
      h += '<small class="np-care-rent-note">' + (rent ? 'En location, vous confirmez Nector Care dans les services complémentaires de la page GreenLeaze.' : (S.cf === 'm12' ? 'Engagement de 12 mensualités. Délai de carence de 30 jours.' : 'Résiliable à tout moment, le mois en cours reste dû. Délai de carence de 30 jours.')) + '</small>';
      h += '<a class="np-care-more" href="' + CARE.url + '" target="_blank" rel="noopener">En savoir plus sur Nector Care</a>';
      list.innerHTML = h;
    }
    var swC = $('sw-care'); if (swC) swC.className = 'np-sw' + (S.care ? ' on' : '');
  }

  function render() {
    var rent = S.mode === 'louer';
    $('pane-louer').hidden = !(rent && cfg.rentOk);
    $('pane-acheter').hidden = rent;
    var tog = root.querySelectorAll('[data-mode]');
    Array.prototype.forEach.call(tog, function (b) { b.className = b.getAttribute('data-mode') === S.mode ? 'on' : ''; });
    $('r-louer').hidden = !rent; $('r-first').hidden = !rent; $('r-buy').hidden = rent;
    $('r-note').hidden = !rent; $('cta-note').hidden = !rent;
    var cta = $('cta'), cta2 = $('cta2');
    cta.textContent = rent ? 'Louer' : 'Ajouter au panier'; cta2.textContent = cta.textContent;
    var Q = S.qty;
    var qv = $('qv'); if (qv) qv.textContent = Q;
    var qh = $('qh'); if (qh) qh.textContent = Q > 1 ? 'Prix pour ' + Q + ' unités' : '';
    Array.prototype.forEach.call(root.querySelectorAll('[data-q]'), function (b) { var d = Number(b.getAttribute('data-qd')); b.disabled = d < 0 ? Q <= 1 : Q >= QMAX; });
    var pb = root.querySelector('[data-role="pane-acheter"] .np-big'); if (pb) pb.textContent = f(eur(cfg.price) * Q) + ' €';
    var pv = root.querySelector('.np-pv'); if (pv) pv.textContent = 'Prix de vente ' + f(eur(cfg.price) * Q) + ' €';

    DURS.forEach(function (d) {
      var g = gl(cfg.price, d); var el = $('m' + d); if (el) el.textContent = g ? f(g.m * Q) : '–';
      var card = root.querySelector('[data-dur="' + d + '"]'); if (card) card.className = 'np-card' + (S.dur === d ? ' sel' : '');
    });
    var g36 = gl(cfg.price, 36), gSel = gl(cfg.price, S.dur);
    var big = $('big'); if (big) big.textContent = g36 ? f(g36.m * Q) : '–';
    var lo = $('lo'); if (lo) lo.textContent = g36 ? f(g36.m * Q) : '–';

    var vis = visibleExtras(), top = $('top');
    if (top) top.innerHTML = vis.slice(0, TOP_N).map(function (e) { return itemHtml(e, rent); }).join('');
    var sheetBtn = $('open-sheet'); if (sheetBtn) { sheetBtn.hidden = vis.length <= TOP_N; sheetBtn.textContent = 'Voir les ' + vis.length + ' accessoires'; }

    var cats = ['Tous'];
    vis.forEach(function (e) { if (cats.indexOf(e.cat) < 0) cats.push(e.cat); });
    var chips = $('chips');
    if (chips) chips.innerHTML = cats.map(function (c) { return '<button type="button" class="np-chip' + (c === S.cat ? ' on' : '') + '" data-cat="' + c + '">' + c + '</button>'; }).join('');
    var grid = $('grid');
    if (grid) grid.innerHTML = vis.filter(function (e) { return S.cat === 'Tous' || e.cat === S.cat; }).map(function (e) { return itemHtml(e, rent); }).join('');

    var n = 0, s = 0, sInit = 0;
    vis.forEach(function (e) {
      var q = S.q[e.id] || 0; if (!q) return; n += q; s += q * extraPrice(e);
      if (rent) { var ge = gl(e.price, S.dur); if (ge) sInit += q * (ge.m + ge.i); }
    });
    ['n', 'n2'].forEach(function (r) { var el = $(r); if (el) el.textContent = n; });
    ['s', 's2'].forEach(function (r) { var el = $(r); if (el) el.textContent = f(s); });
    ['su', 'su2'].forEach(function (r) { var el = $(r); if (el) el.textContent = rent ? '€/mois' : '€'; });

    var swI = $('sw-inst'); if (swI) swI.className = 'np-sw' + (S.inst ? ' on' : '');
    var inst = (S.inst && cfg.installId) ? eur(cfg.installPrice) : 0;
    renderCare(rent);
    var care = (S.care && (rent || CARE.data)) ? careAmt(rent) : 0;

    var note = $('cta-note');
    if (CARE.glNote === null && note) CARE.glNote = note.textContent;
    if (rent) {
      if (note && CARE.glNote !== null) note.textContent = CARE.glNote;
      var m = gSel ? gSel.m * Q + s + care : null;
      var init = gSel ? (gSel.m + gSel.i) * Q + sInit + inst : null;
      $('tm').textContent = m === null ? '–' : f(m);
      $('ti').textContent = init === null ? '–' : f(init);
      $('sticky-price').textContent = m === null ? '–' : f(m) + ' €/mois';
    } else {
      var tot = eur(cfg.price) * Q + s + inst + care;
      $('tb').textContent = f(tot);
      $('sticky-price').textContent = f(tot) + ' €';
      if (note) {
        if (S.care && CARE.data) { note.textContent = 'Dont Nector Care : ' + f(care) + ' €, facturé chaque mois à partir d\'aujourd\'hui.'; note.hidden = false; }
        else { note.hidden = true; }
      }
    }
  }

  function trackId() {
    return window.greenleaze_tracking || (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && window.ShopifyAnalytics.lib.user && window.ShopifyAnalytics.lib.user().traits && window.ShopifyAnalytics.lib.user().traits().uniqToken) || null;
  }
  function err(msg) { var el = $('err'); el.textContent = msg; el.hidden = !msg; }

  async function add() {
    err('');
    var btns = [$('cta'), $('cta2')];
    btns.forEach(function (b) { b.disabled = true; });
    try {
      var rent = S.mode === 'louer';
      var cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
      var inCart = {}; cart.items.forEach(function (i) { inCart[i.variant_id] = true; });
      var items = [];
      var push = function (id, q) { if (!inCart[id]) items.push({ id: id, quantity: q }); };
      push(cfg.variantId, S.qty);
      visibleExtras().forEach(function (e) { var q = S.q[e.id] || 0; if (q > 0) push(e.id, q); });
      if (S.inst && cfg.installId) push(cfg.installId, 1);
      // Achat : Nector Care = abonnement Shopify (1 contrat + produits supplémentaires au-delà de 3 équipements)
      if (!rent && S.care && CARE.data) {
        var D = CARE.data[S.cf], xn = careExtraN();
        if (!inCart[D.id]) items.push({ id: D.id, quantity: 1, selling_plan: D.plan });
        if (xn > 0 && !inCart[CARE.data.extra.id]) items.push({ id: CARE.data.extra.id, quantity: xn, selling_plan: CARE.data.extra.plan });
      }
      // Nector Care en location : pas de ligne panier (GreenLeaze ne la passerait pas en mensuel).
      // Le choix est transmis dans les attributs du panier, envoyés à GreenLeaze avec le panier.
      if (rent) {
        var others = cart.items.filter(function (i) { return i.variant_id !== cfg.variantId; });
        if (others.length && !window.confirm('Votre panier contient déjà d’autres produits : ils seront aussi envoyés en location. Continuer ?')) { btns.forEach(function (b) { b.disabled = false; }); return; }
      }
      if (items.length) {
        var r = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
        if (!r.ok) { var j = {}; try { j = await r.json(); } catch (e) {} throw new Error(j.description || j.message || 'Ajout au panier impossible.'); }
      }
      if (rent) {
        var attrs = { 'Nector Care': S.care ? 'Oui' : 'Non' };
        if (S.care) { attrs['Nector Care - équipements'] = String(S.qty + accCount()); attrs['Nector Care - mensualité'] = f(careAmt(true)) + ' €'; }
        await fetch(window.Shopify.routes.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
        if (typeof sendCartAndRedirect !== 'function') throw new Error('Le service de location est momentanément indisponible.');
        var ok = await sendCartAndRedirect(S.dur, cfg.variantId, trackId());
        if (ok === false) throw new Error('Le service de location a renvoyé une erreur. Réessayez.');
      } else {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    } catch (e) {
      err(e.message || 'Une erreur est survenue.');
      btns.forEach(function (b) { b.disabled = false; });
    }
  }

  function closeSheet() { var sh = $('sheet'); if (sh) sh.classList.remove('open'); }
  // Fermeture du volet : clic en dehors (phase de capture, avant tout re-rendu) ou touche Echap
  document.addEventListener('click', function (ev) {
    var sh = $('sheet');
    if (!sh || !sh.classList.contains('open')) return;
    var t = ev.target;
    if (sh.contains(t) || (t.closest && t.closest('[data-role="open-sheet"]'))) return;
    ev.preventDefault(); ev.stopPropagation(); closeSheet();
  }, true);
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeSheet(); });

  root.addEventListener('click', function (ev) {
    var t = ev.target;
    var btn = t.closest ? t.closest('button,[data-dur]') : null;
    if (!btn) { var th = t.closest && t.closest('.np-thumbs img'); if (th) { var m = document.getElementById('np-main'); if (m) m.src = th.getAttribute('data-full'); } return; }
    if (btn.hasAttribute('data-mode')) { S.mode = btn.getAttribute('data-mode'); render(); return; }
    if (btn.hasAttribute('data-dur')) { S.dur = Number(btn.getAttribute('data-dur')); render(); return; }
    if (btn.hasAttribute('data-care-f')) { S.cf = btn.getAttribute('data-care-f'); render(); return; }
    if (btn.hasAttribute('data-q')) { S.qty = Math.max(1, Math.min(QMAX, S.qty + Number(btn.getAttribute('data-qd')))); render(); return; }
    if (btn.hasAttribute('data-x')) { var id = btn.getAttribute('data-x'); S.q[id] = Math.max(0, Math.min(3, (S.q[id] || 0) + Number(btn.getAttribute('data-d')))); render(); return; }
    if (btn.hasAttribute('data-cat')) { S.cat = btn.getAttribute('data-cat'); render(); return; }
    var role = btn.getAttribute('data-role');
    if (role === 'sw-inst') { S.inst = !S.inst; render(); }
    else if (role === 'sw-care') { S.care = !S.care; render(); }
    else if (role === 'open-sheet') { $('sheet').classList.add('open'); }
    else if (role === 'close-sheet') { closeSheet(); }
    else if (role === 'cta' || role === 'cta2') { add(); }
  });

  var qp = new URLSearchParams(window.location.search).get('mode');
  if (qp === 'acheter' && cfg.buyOk) S.mode = 'acheter';
  if (qp === 'louer' && cfg.rentOk) S.mode = 'louer';
  if (!cfg.rentOk) S.mode = 'acheter';
  mountQty();
  render();
  ready(render);
  loadCare();
})();